// extracted by mini-css-extract-plugin
export default {"image":"M2-z","loaded":"N2-z"};